import {
  DEFAULT_LOCALE,
  GET_WORD_PAIR_FAILURE,
  GET_WORD_PAIR_REQUEST,
  GET_WORD_PAIR_SUCCESS,
} from '../constants';
import { put, select, takeLatest } from 'redux-saga/effects';
import { IGetWordPairRequest, ISetWordPairAction } from '../reducers/wordPair';
import { WordPair } from '../models';
import { RootState } from "../reducers";
import { IGetWordPairFailure } from "../reducers/errorMessage";
import { callApi } from '../api';

const onGetWordPair = function* () {
  try {
    const showRemembered: boolean = yield select((state: RootState) => state.showRemembered);
    const bearerToken: string = yield select((state: RootState) => state.bearerToken);

    const uri = `/word-pair?locale=${DEFAULT_LOCALE}&options=5${(showRemembered ? '&includeRemembered=1' : '')}`;

    const wordPair: WordPair = yield callApi(
      uri,
      bearerToken,
    );

    yield put<ISetWordPairAction>({
      type: GET_WORD_PAIR_SUCCESS,
      wordPair,
    });
  } catch(e) {
    console.error(e);

    yield put<IGetWordPairFailure>({
      type: GET_WORD_PAIR_FAILURE,
      message: e.message || 'Something went wrong.',
    });
  }
};

const watchGetWordPair = function* () {
  yield takeLatest<IGetWordPairRequest>(GET_WORD_PAIR_REQUEST, onGetWordPair);
};

export {
  watchGetWordPair,
};
